// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

/* Configuração responsiva com base de font-size adaptável */
html {
  font-size: clamp(12px, 1.2vw, 16px); /* Escala fluida baseada na viewport */
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* font-size: 0.8rem; */
  line-height: 1.3;
}

/* Configuração global para elementos compactos */
* {
  box-sizing: border-box;
}

.card {
  border-radius: 0.5rem !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.card-body {
  padding: clamp(0.75rem, 2vw, 1.25rem) !important;
}

.modal-header {
  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 1.5rem) !important;
  border-bottom: 1px solid #dee2e6 !important;
}

.modal-body {
  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 1.5rem) !important;
}

.modal-footer {
  padding: clamp(0.2rem, 0.8vw, 0.35rem) clamp(0.4rem, 1.2vw, 0.75rem) !important;
  border-top: 1px solid #dee2e6 !important;
}

/* Correção para ícones posicionados sobre inputs */
.position-relative {
  position: relative !important;
}

.position-relative .position-absolute {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10;
}

.position-relative .position-absolute svg {
  width: clamp(16px, 2.5vw, 20px) !important;
  height: clamp(16px, 2.5vw, 20px) !important;
}

/* Ícones no lado esquerdo dos inputs */
.position-relative .position-absolute.start-0 {
  left: clamp(0.75rem, 2vw, 1rem) !important;
}

/* Ícones no lado direito dos inputs */
.position-relative .position-absolute.end-0 {
  right: clamp(0.75rem, 2vw, 1rem) !important;
}

/* Ajuste de padding para inputs com ícones */
.form-control.has-icon-left {
  padding-left: clamp(2.5rem, 6vw, 3rem) !important;
}

.form-control.has-icon-right {
  padding-right: clamp(2.5rem, 6vw, 3rem) !important;
}

/* Para inputs de pesquisa especificamente */
.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-container .form-control {
  padding-left: clamp(2.5rem, 6vw, 3rem) !important;
  padding-right: clamp(0.75rem, 2vw, 1rem) !important;
}

.search-input-container .search-icon {
  position: absolute;
  left: clamp(0.75rem, 2vw, 1rem);
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  pointer-events: none;
  color: #6c757d;
}


.btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 59, 107, 0.25) !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.card,
.btn,
.modal,
.dropdown-menu,
.popover,
.form,
.form-control,
.accordion,
.accordion-item,
.form-select,
.accordion-header,
.accordion-button .form-select {
  box-shadow: none !important;
}

.custom-select__control {
  box-shadow: none !important;
  border-color: transparent !important;
}

.custom-select__control:hover {
  box-shadow: none !important;
  border-color: transparent !important;
}

.custom-modal-dialog {
  width: min(96vw, 1400px) !important;
  max-width: 98vw !important;
  margin: clamp(0.25rem, 1vh, 0.75rem) auto !important;
  height: min(96vh, 800px) !important;
}

.custom-modal-dialog .modal-content {
  height: 100% !important;
  border: none;
  border-radius: clamp(8px, 1vw, 12px);
  box-shadow: 0 clamp(15px, 2vw, 25px) clamp(30px, 4vw, 50px) rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.custom-modal-dialog .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: clamp(0.15rem, 0.5vw, 0.3rem) !important;
  min-height: 0;
}

/* Media queries melhoradas para diferentes tamanhos e escalas */

/* Configuração base responsiva com font-size adaptável */
@media screen and (max-width: 1600px) {
  html {
    font-size: 15px;
  }
}

@media screen and (max-width: 1200px) {
  html {
    font-size: 14px;
  }
}

@media screen and (max-width: 992px) {
  html {
    font-size: 13px;
  }
}

/* Tablets e dispositivos médios */
@media screen and (max-width: 768px) {
  html {
    font-size: 12px;
  }

  .custom-modal-dialog {
    width: 95vw !important;
    height: 85vh !important;
    margin: clamp(1rem, 5vh, 3rem) auto !important;
    max-height: calc(100vh - 2rem);
  }

  .custom-modal-dialog .modal-content {
    height: 100% !important;
    max-height: none;
  }

  .custom-modal-dialog .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    padding: clamp(0.75rem, 2vw, 1rem) !important;
  }

  /* Elementos de interface mais compactos */
  .btn {
    padding: clamp(0.4rem, 1.5vw, 0.75rem) clamp(0.75rem, 3vw, 1.25rem) !important;
    font-size: clamp(0.8rem, 2.5vw, 1rem) !important;
  }

  .form-control {
    padding: clamp(0.5rem, 2vw, 0.75rem) !important;
    font-size: clamp(0.85rem, 2.5vw, 1rem) !important;
  }

  .card-body {
    padding: clamp(0.5rem, 2.5vw, 1rem) !important;
  }
}

/* Dispositivos pequenos e notebooks com escala alta */
@media screen and (max-width: 576px), screen and (max-height: 600px) {
  html {
    font-size: 11px;
  }

  .btn {
    padding: 0.4rem 0.8rem !important;
    font-size: 0.8rem !important;
  }

  .form-control {
    padding: 0.4rem 0.6rem !important;
    font-size: 0.85rem !important;
  }

  .modal-header, .modal-body, .modal-footer {
    padding: 0.75rem !important;
  }
}

/* Para telas muito pequenas ou com zoom alto */
@media screen and (max-width: 480px) {
  html {
    font-size: 10px;
  }
}

.custom-modal-dialogF {
  margin: 0 !important;           
  width: 100vw !important;        
  max-width: none !important;     
  height: 100vh !important;       
  padding: 0;                     
}

.custom-modal-dialogF .modal-content {
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;               
}

.custom-modal-dialogF .modal-body {
  padding: 0;
  overflow-y: auto;              
}

@keyframes fadeHighlight {
  0% {
    background-color: rgba(255, 255, 0, 0.5);
  }

  100% {
    background-color: transparent;
  }
}

@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.just-moved {
  animation: fadeHighlight 0.6s ease-out !important;
}

.form-check-input:focus {
  outline: none;
  box-shadow: none !important;
}

/* Remover bordas azuis de inputs, selects e outros elementos de formulário */
.form-control:focus,
.form-select:focus,
input:focus,
select:focus,
textarea:focus {
  border-color: #ced4da !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Remover outline de gráficos Recharts */
svg:focus {
  outline: none !important;
}

.recharts-wrapper:focus,
.recharts-surface:focus {
  outline: none !important;
}

/* Remover outline de todos os elementos interativos dos gráficos */
.recharts-wrapper *:focus,
.recharts-surface *:focus {
  outline: none !important;
}

/* Dropdown de exportação - garantir que fique acima de tudo */
.export-dropdown-menu {
  z-index: 999999 !important;
  min-width: 220px !important;
}

.dropdown-menu.show {
  z-index: 999999 !important;
}

.dropdown-menu {
  z-index: 999999 !important;
}

/* Garantir que itens do dropdown sejam visíveis */
.dropdown-item {
  white-space: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,mCAAmC,EAAE,sCAAsC;AAC7E;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yEAAyE;EACzE,2CAA2C;AAC7C;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,+EAA+E;EAC/E,wCAAwC;AAC1C;;AAEA,mDAAmD;AACnD;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,0CAA0C;AAC5C;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;AAC7C;;AAEA,6CAA6C;AAC7C;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,cAAc;AAChB;;;AAGA;EACE,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,oDAAoD;EACpD,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,+EAA+E;EAC/E,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;AACf;;AAEA,gEAAgE;;AAEhE,yDAAyD;AACzD;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;IAC9C,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,6CAA6C;EAC/C;;EAEA,0CAA0C;EAC1C;IACE,8EAA8E;IAC9E,gDAAgD;EAClD;;EAEA;IACE,+CAA+C;IAC/C,iDAAiD;EACnD;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;;;;;EAKE,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;;EAEE,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;AAChC","sourcesContent":[".App {\n  text-align: center;\n}\n\n/* Configuração responsiva com base de font-size adaptável */\nhtml {\n  font-size: clamp(12px, 1.2vw, 16px); /* Escala fluida baseada na viewport */\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* font-size: 0.8rem; */\n  line-height: 1.3;\n}\n\n/* Configuração global para elementos compactos */\n* {\n  box-sizing: border-box;\n}\n\n.card {\n  border-radius: 0.5rem !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;\n}\n\n.card-body {\n  padding: clamp(0.75rem, 2vw, 1.25rem) !important;\n}\n\n.modal-header {\n  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 1.5rem) !important;\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.modal-body {\n  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 1.5rem) !important;\n}\n\n.modal-footer {\n  padding: clamp(0.2rem, 0.8vw, 0.35rem) clamp(0.4rem, 1.2vw, 0.75rem) !important;\n  border-top: 1px solid #dee2e6 !important;\n}\n\n/* Correção para ícones posicionados sobre inputs */\n.position-relative {\n  position: relative !important;\n}\n\n.position-relative .position-absolute {\n  position: absolute !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  z-index: 10;\n}\n\n.position-relative .position-absolute svg {\n  width: clamp(16px, 2.5vw, 20px) !important;\n  height: clamp(16px, 2.5vw, 20px) !important;\n}\n\n/* Ícones no lado esquerdo dos inputs */\n.position-relative .position-absolute.start-0 {\n  left: clamp(0.75rem, 2vw, 1rem) !important;\n}\n\n/* Ícones no lado direito dos inputs */\n.position-relative .position-absolute.end-0 {\n  right: clamp(0.75rem, 2vw, 1rem) !important;\n}\n\n/* Ajuste de padding para inputs com ícones */\n.form-control.has-icon-left {\n  padding-left: clamp(2.5rem, 6vw, 3rem) !important;\n}\n\n.form-control.has-icon-right {\n  padding-right: clamp(2.5rem, 6vw, 3rem) !important;\n}\n\n/* Para inputs de pesquisa especificamente */\n.search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input-container .form-control {\n  padding-left: clamp(2.5rem, 6vw, 3rem) !important;\n  padding-right: clamp(0.75rem, 2vw, 1rem) !important;\n}\n\n.search-input-container .search-icon {\n  position: absolute;\n  left: clamp(0.75rem, 2vw, 1rem);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  pointer-events: none;\n  color: #6c757d;\n}\n\n\n.btn:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 59, 107, 0.25) !important;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.card,\n.btn,\n.modal,\n.dropdown-menu,\n.popover,\n.form,\n.form-control,\n.accordion,\n.accordion-item,\n.form-select,\n.accordion-header,\n.accordion-button .form-select {\n  box-shadow: none !important;\n}\n\n.custom-select__control {\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n.custom-select__control:hover {\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n.custom-modal-dialog {\n  width: min(96vw, 1400px) !important;\n  max-width: 98vw !important;\n  margin: clamp(0.25rem, 1vh, 0.75rem) auto !important;\n  height: min(96vh, 800px) !important;\n}\n\n.custom-modal-dialog .modal-content {\n  height: 100% !important;\n  border: none;\n  border-radius: clamp(8px, 1vw, 12px);\n  box-shadow: 0 clamp(15px, 2vw, 25px) clamp(30px, 4vw, 50px) rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-modal-dialog .modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: clamp(0.15rem, 0.5vw, 0.3rem) !important;\n  min-height: 0;\n}\n\n/* Media queries melhoradas para diferentes tamanhos e escalas */\n\n/* Configuração base responsiva com font-size adaptável */\n@media screen and (max-width: 1600px) {\n  html {\n    font-size: 15px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  html {\n    font-size: 13px;\n  }\n}\n\n/* Tablets e dispositivos médios */\n@media screen and (max-width: 768px) {\n  html {\n    font-size: 12px;\n  }\n\n  .custom-modal-dialog {\n    width: 95vw !important;\n    height: 85vh !important;\n    margin: clamp(1rem, 5vh, 3rem) auto !important;\n    max-height: calc(100vh - 2rem);\n  }\n\n  .custom-modal-dialog .modal-content {\n    height: 100% !important;\n    max-height: none;\n  }\n\n  .custom-modal-dialog .modal-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    padding: clamp(0.75rem, 2vw, 1rem) !important;\n  }\n\n  /* Elementos de interface mais compactos */\n  .btn {\n    padding: clamp(0.4rem, 1.5vw, 0.75rem) clamp(0.75rem, 3vw, 1.25rem) !important;\n    font-size: clamp(0.8rem, 2.5vw, 1rem) !important;\n  }\n\n  .form-control {\n    padding: clamp(0.5rem, 2vw, 0.75rem) !important;\n    font-size: clamp(0.85rem, 2.5vw, 1rem) !important;\n  }\n\n  .card-body {\n    padding: clamp(0.5rem, 2.5vw, 1rem) !important;\n  }\n}\n\n/* Dispositivos pequenos e notebooks com escala alta */\n@media screen and (max-width: 576px), screen and (max-height: 600px) {\n  html {\n    font-size: 11px;\n  }\n\n  .btn {\n    padding: 0.4rem 0.8rem !important;\n    font-size: 0.8rem !important;\n  }\n\n  .form-control {\n    padding: 0.4rem 0.6rem !important;\n    font-size: 0.85rem !important;\n  }\n\n  .modal-header, .modal-body, .modal-footer {\n    padding: 0.75rem !important;\n  }\n}\n\n/* Para telas muito pequenas ou com zoom alto */\n@media screen and (max-width: 480px) {\n  html {\n    font-size: 10px;\n  }\n}\n\n.custom-modal-dialogF {\n  margin: 0 !important;           \n  width: 100vw !important;        \n  max-width: none !important;     \n  height: 100vh !important;       \n  padding: 0;                     \n}\n\n.custom-modal-dialogF .modal-content {\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;               \n}\n\n.custom-modal-dialogF .modal-body {\n  padding: 0;\n  overflow-y: auto;              \n}\n\n@keyframes fadeHighlight {\n  0% {\n    background-color: rgba(255, 255, 0, 0.5);\n  }\n\n  100% {\n    background-color: transparent;\n  }\n}\n\n@keyframes slideInRight {\n  0% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.just-moved {\n  animation: fadeHighlight 0.6s ease-out !important;\n}\n\n.form-check-input:focus {\n  outline: none;\n  box-shadow: none !important;\n}\n\n/* Remover bordas azuis de inputs, selects e outros elementos de formulário */\n.form-control:focus,\n.form-select:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: #ced4da !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Remover outline de gráficos Recharts */\nsvg:focus {\n  outline: none !important;\n}\n\n.recharts-wrapper:focus,\n.recharts-surface:focus {\n  outline: none !important;\n}\n\n/* Remover outline de todos os elementos interativos dos gráficos */\n.recharts-wrapper *:focus,\n.recharts-surface *:focus {\n  outline: none !important;\n}\n\n/* Dropdown de exportação - garantir que fique acima de tudo */\n.export-dropdown-menu {\n  z-index: 999999 !important;\n  min-width: 220px !important;\n}\n\n.dropdown-menu.show {\n  z-index: 999999 !important;\n}\n\n.dropdown-menu {\n  z-index: 999999 !important;\n}\n\n/* Garantir que itens do dropdown sejam visíveis */\n.dropdown-item {\n  white-space: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
